import { pqstatusgruppe } from './../../../utils/apiTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { gruppenState } from './gruppenTypes';
import { AppDispatch, RootState } from '../../../app/store';
import { getWithAuth } from '../../../utils/api';
import { logError } from '../../../utils/utils';
import { errorHandler } from '../../../utils/errorHandling';

const initialState: gruppenState = {
    pqstatusgruppe: [],
    pqstatusGruppeLoading: false,
}

const gruppenSlice = createSlice({
    name: "gruppen",
    initialState,
    reducers: {
        setPQStatusGruppe: (state, action: PayloadAction<Array<pqstatusgruppe>>) => {
            state.pqstatusgruppe = action.payload;
        },
        setPQStatusGruppeLoading: (state, action: PayloadAction<boolean>) => {
            state.pqstatusGruppeLoading = action.payload;
        },

    }
});

export const {
    setPQStatusGruppe,
    setPQStatusGruppeLoading,
} = gruppenSlice.actions

export const selectPQStatusGruppe = (state: RootState): Array<pqstatusgruppe> => state.gruppen.pqstatusgruppe;
export const selectPQStatusGruppeLoading = (state: RootState): boolean => state.gruppen.pqstatusGruppeLoading;

export const getPQStatusGruppe = () => (dispatch: AppDispatch): void => {
    dispatch(setPQStatusGruppeLoading(true));
    getWithAuth("PQSTATUSGRUPPE", {})
        .then((status: Array<pqstatusgruppe>) => dispatch(setPQStatusGruppe(status)))
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        })
        .finally(() => dispatch(setPQStatusGruppeLoading(false)));
}

export default gruppenSlice.reducer